import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';

const Register = () => {
    const [formData, setFormData] = useState({
        originState: '',
        destinationState: '',
    });

    const states = [
        'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 
        'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 
        'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://back.bidolux.jmatecnologia.inf.br/api/new-shipping', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
    
            const data = await response.json();
            console.log(data);
            alert(data.message);
        } catch (error) {
            console.error('Erro ao enviar os dados:', error);
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Container className="py-4">
            <Row className="justify-content-center">
                <Col md={8}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Registro de Nova Rota</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Estado de Origem</Form.Label>
                                            <Form.Select
                                                name="originState"
                                                value={formData.originState}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Selecione o estado</option>
                                                {states.map(state => (
                                                    <option key={state} value={state}>
                                                        {state}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Estado de Destino</Form.Label>
                                            <Form.Select
                                                name="destinationState"
                                                value={formData.destinationState}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Selecione o estado</option>
                                                {states.map(state => (
                                                    <option key={state} value={state}>
                                                        {state}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className="d-grid gap-2">
                                    <Button variant="primary" type="submit">
                                        Registrar
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Register;